import CMS from 'netlify-cms-app'
import uploadcare from 'netlify-cms-media-library-uploadcare'
import cloudinary from 'netlify-cms-media-library-cloudinary'
import './cms-utils'

import BeliefsPagePreview from './preview-templates/BeliefsPagePreview'
import EventsPagePreview from './preview-templates/EventsPagePreview'
import IndexPagePreview from './preview-templates/IndexPagePreview'
import LivestreamPagePreview from './preview-templates/LivestreamPagePreview'
import PrayerPagePreview from './preview-templates/PrayerPagePreview'
import YouthPagePreview from './preview-templates/YouthPagePreview'
import ContactPagePreview from './preview-templates/ContactPagePreview'

CMS.registerMediaLibrary(uploadcare)
CMS.registerMediaLibrary(cloudinary)

CMS.registerPreviewTemplate('index', IndexPagePreview)
CMS.registerPreviewTemplate('beliefs', BeliefsPagePreview)
CMS.registerPreviewTemplate('events', EventsPagePreview)
CMS.registerPreviewTemplate('livestream', LivestreamPagePreview)
CMS.registerPreviewTemplate('prayer', PrayerPagePreview)
CMS.registerPreviewTemplate('youth', YouthPagePreview)
CMS.registerPreviewTemplate('contact', ContactPagePreview)
